const TmpPE013 = (page, section) => {
  const media = [];
  const materials = [];
  const images = [];
  const eMentors = [];
  const modifiedPage = {
    ...page
  };

  let content = {
    id: page.content.core.id,
    type_id: page.content.core.type_id
  };

  switch (page.content.core.type_id) {
    case 1:
      // Handle Video content
      content.context = page.content.core.context || '';
      // add the media object to the media array
      const videoMedia = {
        ...page.content.core.media,
        page: page.id,
        id: page.id,
        src: page.label.toLowerCase().replaceAll('-', '_') + '.mp4'
      };
      // add the media object to the media array
      media.push(videoMedia);
      // modify the media object to strip out the unnecessary data
      const video = {
        content: {
          cc: page.content.cc || [],
          focus_points: page.content.focus_points || [],
          media: videoMedia,
          questions: page.content.questions || []
        },
        page: page.id,
        section: section,
        type: 'video'
      };
      // add the media object to the media array
      materials.push(video);
      // add the material reference to the content object
      content.material = page.id;
      break;
    case 2:
      // Handle Audio
      content.context = page.content.core.context || '';
      // add the media object to the media array
      const audioMedia = {
        ...page.content.core.media,
        page: page.id,
        id: page.id,
        src: page.label.toLowerCase().replaceAll('-', '_') + '.mp3'
      };
      // add the media object to the media array
      media.push(audioMedia);
      // modify the media object to strip out the unnecessary data
      const audio = {
        content: {
          cc: page.content.cc || [],
          focus_points: page.content.focus_points || [],
          media: audioMedia
        },
        page: page.id,
        section: section,
        type: 'audio'
      };
      // add the media object to the media array
      materials.push(audio);
      // add the material reference to the content object
      content.material = page.id;
      break;
    case 3:
      // Handle Image content
      content.media = page.content.core.media || {};
      content.media.src =
        page.label.toLowerCase().replaceAll('-', '_') + '.jpg';
      content.context = page.content.core.context || '';
      // add the image object to the media and images arrays
      const image = {
        size: '960px X 540px',
        ...content.media,
        page: page.id
      };
      media.push(image);
      images.push(image);
      break;
    case 4:
      // Handle Image
      content.media = page.content.core.media || {};
      content.media.src =
        page.label.toLowerCase().replaceAll('-', '_') + '.jpg';
      content.prompt = page.content.core.prompt || 'MISSING PROMPT';
      content.lures = page.content.core.lures || [];
      content.correct_feedback =
        page.content.core.correct_feedback || 'MISSING CORRECT FEEDBACK';
      content.incorrect_feedback =
        [
          page.content.core.incorrect_feedback_1,
          page.content.core.incorrect_feedback_2,
          page.content.core.incorrect_feedback_3
        ] || [];
      // add the image object to the media and images arrays
      const imageMC = {
        size: '960px X 540px',
        ...content.media,
        page: page.id
      };
      media.push(imageMC);
      images.push(imageMC);
      break;
    default:
      // Handle eMentor Notes
      content.eMentor = page.content.core.eMentor || [];
      break;
  }

  // update the the ementor content with the page id
  if (page.content.core.eMentor) {
    page.content.core.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Update the modifiedPage with the new content structure
  modifiedPage.content.core = content;

  delete modifiedPage.instructions;

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: materials || [],
    eMentor: eMentors,
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE013;
